<template>
  <div>
    <v-container class="text-xs-center">
      <img src="/static/logo.png" alt="Logo">
      <h1 class="mt-3">PÁGINA NÃO ENCONTRADA</h1>
      <v-btn to="/" large class="mt-3" dark color="primary">VOLTAR</v-btn>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'not-found',
}
</script>



// WEBPACK FOOTER //
// src/views/NotFound.vue